// extracted by mini-css-extract-plugin
module.exports = {"container":"sports-layout_container__lrb1l","noGame":"sports-layout_noGame__X0t_4"};